













































import {
  defineComponent, ref, computed, Ref, watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { mapChart } from 'highcharts';

import mapData from '@/components/Map/th-all.geo.json';

const DeliveryHeatMap = defineComponent({
  props: {
    maxWidth: {
      type: String,
      default() { return '800'; },
    },
    title: { default: '' },
    unit: { default: '' },
    entity: { default: '' },
    data: {
      default() {
        return {
          central: [], eastern: [], northeastern: [], northern: [], southern: [], western: [],
        };
      },
    },
    regions: {
      default: () => ({
        unit: '',
        data: [
          { data: 0 },
          { data: 0 },
          { data: 0 },
          { data: 0 },
          { data: 0 },
        ],
      }),
    },
    height: { type: Number, default: 830 },
  },
  setup(props: any) {
    // eslint-disable-next-line
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const isUserZoom: Ref<boolean> = ref(false);

    const regionColors = {
      northern: '#ffc2c2',
      'northern-text': '#b51818',
      northeastern: '#ffdc96',
      'northeastern-text': '#e0a328',
      central: '#bbffb5',
      'central-text': '#3dbf32',
      eastern: '#61ffef',
      'eastern-text': '#1cb8a9',
      western: '#85beff',
      'western-text': '#4099ff',
      southern: '#e2b5ff',
      'southern-text': '#ae2bff',
      class: 'stroke-1 font-bold text-xs',
    };
    const chartDataLabel = {
      northern: { enabled: true, format: `<span style="color: ${regionColors['northern-text']};" class="${regionColors.class}">{point.name}</span>` },
      northeastern: { enabled: true, format: `<span style="color: ${regionColors['northeastern-text']};" class="${regionColors.class}">{point.name}</span>` },
      central: { enabled: true, format: `<span style="color: ${regionColors['central-text']};" class="${regionColors.class}">{point.name}</span>` },
      eastern: { enabled: true, format: `<span style="color: ${regionColors['eastern-text']};" class="${regionColors.class}">{point.name}</span>` },
      western: { enabled: true, format: `<span style="color: ${regionColors['western-text']};" class="${regionColors.class}">{point.name}</span>` },
      southern: { enabled: true, format: `<span style="color: ${regionColors['southern-text']};" class="${regionColors.class}">{point.name}</span>` },
    };
    const chartTooltip = {
      headerFormat: '',
      pointFormat: `<b>{point.name}</b> <br> ${props.entity}: {point.value} ${props.unit}`,
    };
    /* eslint-disable */
    const chartOptions = computed(() => ({
      plotOptions: {
        type: 'heatmap',
      },
      chart: {
        map: mapData,
        height: props.height,
        width: 700,
      },
      title: {
        text: props.title,
      },
      subtitle: {
        text: '',
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          alignTo: 'spacingBox',
        },
      },
      yAxis: [{
        events: {
          afterSetExtremes: ($event: {
            dataMax: number; dataMin: number; max: number; min: number;
          }) => {
            if ($event.max > $event.dataMax) isUserZoom.value = false;
            else isUserZoom.value = true;
          },
          setExtremes: ($event: {
            dataMax: number; dataMin: number; max: number; min: number;
          }) => {
            if ($event.max > $event.dataMax) isUserZoom.value = false;
            else isUserZoom.value = true;
          },
        },
      }],
      colorAxis: [
        {
          min: 1,
          minColor: '#ecf8ff',
          maxColor: '#113561',
        },
      ],
      series: [
        {
          name: 'CENTRAL',
          allAreas: false,
          states: {
            hover: { color: regionColors.central },
          },
          color: regionColors.central,
          dataLabels: chartDataLabel.central,
          data: props.data.central,
          tooltip: chartTooltip,
        },
        {
          name: 'NORTHERN',
          allAreas: false,
          states: {
            hover: { color: regionColors.northern },
          },
          color: regionColors.northern,
          dataLabels: chartDataLabel.northern,
          data: props.data.northern,
          tooltip: chartTooltip,
        },
        {
          name: 'WESTERN',
          allAreas: false,
          states: {
            hover: { color: regionColors.western },
          },
          color: regionColors.western,
          dataLabels: chartDataLabel.western,
          data: props.data.western,
          tooltip: chartTooltip,
        },
        {
          name: 'eastern',
          allAreas: false,
          states: {
            hover: { color: regionColors.eastern },
          },
          color: regionColors.eastern,
          dataLabels: chartDataLabel.eastern,
          data: props.data.eastern,
          tooltip: chartTooltip,
        },
        {
          name: 'northeastern',
          allAreas: false,
          states: {
            hover: { color: regionColors.northeastern },
          },
          color: regionColors.northeastern,
          dataLabels: chartDataLabel.northeastern,
          data: props.data.northeastern,
          tooltip: chartTooltip,
        },
        {
          name: 'southern',
          allAreas: false,
          states: {
            hover: { color: regionColors.southern },
          },
          color: regionColors.southern,
          dataLabels: chartDataLabel.southern,
          data: props.data.southern,
          tooltip: chartTooltip,
        },
      ],
    }));

    function renderChart() {
      mapChart('chart', chartOptions.value as any);
    }

    watch(() => props.data, _.debounce(() => {
      renderChart();
    }, 200))

    return {
      toCurrency,

      isUserZoom,

      chartOptions,

      regionColors,
    };
  },
});

export default DeliveryHeatMap;
